// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  WIDGET_URL: 'https://widget-dev.yoint.co/',
  IDCLIENT: 'cug787v7mkj89n8g02e789pqb',
  PASSWORDCLIENT: '5u9s2j32eb09v5q53devu69hh50quamdqerfduovhkv66ph8b3b',
  //WIDGET_URL: 'http://localhost:4200/',
  //YOINT_URL: 'http://localhost:5000/api/v1/users',
  //YOINT_URL: 'http://localhost:5000/api/v2/users',
  //YOINT_URL: 'https://api-dev.yoint.co/api/v1/users',
  YOINT_URL: 'https://api-dev.yoint.co/api/v2/users',
  YOINT_BANKS: 'https://api-dev.yoint.co/api/banks',
  COGNITO_URL: 'https://j1ejspw0g1.execute-api.us-east-1.amazonaws.com/develop/yoint-api/oauth2/token',
  SWAGGER_URL:
    'https://qrqwxppu3f.execute-api.us-east-1.amazonaws.com/dev/test',
  GA: 'G-MVZFBPB8WY',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
